import React, { useState, useEffect } from "react";

import { Avatar, Box, Tooltip } from "@mui/material";
import {
  Profile as ProfileComponent,
  Loader,
  OwnerForm,
  AddOwner,
} from "../../components";
import Select from "react-select";
import { PageStructure } from "..";
import apiUrl from "../../components/api";
import axios from "axios";
import io from "socket.io-client";

const getColor = (name) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = `hsl(${hash % 360}, 100%, 30%)`;
  return color;
};

const EditOwner = () => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
  const [loading, setLoading] = useState(true);

  const [owners, setOwners] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchOwners = async () => {
      try {
        const response = await axios.get(`${apiUrl}/auth/owners`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        });
        setOwners(response.data.owners);
        setLoading(false);
      } catch (error) {
        setError("Failed to fetch owners. Please try again.");
      }
    };
    fetchOwners();
  }, [user.token]);

  // Add socket connection for real-time balance updates
  useEffect(() => {
    const socket = io(apiUrl);

    // Listen for owner balance updates
    socket.on("user", (data) => {
      console.log("Socket received - user:", data);
      if (data.action === "updateBalance" && data.user) {
        // Update the owners array to reflect balance changes in the Select component
        setOwners((prevOwners) =>
          prevOwners.map((owner) =>
            owner._id === data.user._id
              ? { ...owner, balance: data.user.balance }
              : owner
          )
        );
      }
    });

    // Cleanup socket listeners on component unmount
    return () => {
      socket.off("user");
      socket.disconnect();
    };
  }, []);

  return (
    <PageStructure>
      <h2>Owners</h2>
      {/* <AddOwner /> */}

      <Select
        options={owners.map((owner) => ({
                value: owner._id,
                label: `€${owner.balance} -${owner.name} - ${
                  owner.tax_id || "No Tax ID"
                } - ${
                  owner.companies.length > 0
                    ? owner.companies.map((company) => company.taxId).join(", ")
                    : "No Companies"
                } - ${owner.properties.map((property) => property.name)}`,
              }))}
        placeholder="Select owners..."
        onChange={(selectedOptions) => {
          setSelectedOwner(selectedOptions.value);
        }}
      />

      {loading && <Loader />}
      {selectedOwner && (
        <AddOwner
            user={selectedOwner}
            edit={true}
        />
      )}
    </PageStructure>
  );
};

export default EditOwner;
